export type KeyedCopyEntry = {
	key: string;
	text: string;
};

/** Shape used by CTA_COPY / COPY-style keyed copy constants. */
export type KeyedCopyConstant = {
	key: string;
	fallback: string;
};

/**
 * Returns trimmed text for the first keyed copy entry whose `key` matches.
 * Unknown keys or blank text yield an empty string. Pass `[]` when there is no list.
 */
export function getKeyedCopyText(
	entries: KeyedCopyEntry[],
	key: string
): string {
	const match = entries.find((entry) => entry.key === key);
	return match?.text?.trim() ?? "";
}

/**
 * Resolves CMS keyed copy for a `{key, fallback}` constant, falling back when
 * the entry is missing or blank.
 */
export function getKeyedCopy(
	entries: KeyedCopyEntry[],
	copy: KeyedCopyConstant
): string {
	return getKeyedCopyText(entries, copy.key) || copy.fallback;
}
